import React from 'react';
import { RedocStandalone } from 'redoc';
import url from 'src/util/url';

function ApiSpecPage() {

    return <>
        <RedocStandalone specUrl={url.api("v5/swagger")} options={{
            theme: {
                colors: {
                    primary: {
                        main: '#F89828'
                    }
                }
            },
        }} />
    </>;
}

export default ApiSpecPage;